<template>
    <div class="page-container">
        <!-- 头部 -->
        <div class="top-block">
            <div class="content-wrapper">
                <van-icon name="passed" size="40" color="#fff" />
                <div class="info-block">
                    <div class="status">已开票</div>
                    <div class="time">开票时间：2020-12-12</div>
                </div>
            </div>
        </div>
        <!-- 页面下部 -->
        <div class="page-bottom">
            <div class="section">
                <div class="section-row">
                    <div class="row-left">发票总金额</div>
                    <div class="row-right">20000元</div>
                </div>
                <div class="section-row goods-info">
                    <div class="row-left">商品信息</div>
                    <div class="row-right">
                        <div class="info-row">御粮春生 20000元 100/瓶</div>
                        <div class="info-row">御粮春生 20000元 100/瓶</div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="section-row">
                    <div class="row-left">发票类型</div>
                    <div class="row-right">增值税电子普通发票</div>
                </div>
                <div class="section-row">
                    <div class="row-left">抬头类型</div>
                    <div class="row-right">个人</div>
                </div>
                <div class="section-row">
                    <div class="row-left">发票抬头</div>
                    <div class="row-right">北京xxx科技有限公司</div>
                </div>
                <div class="section-row">
                    <div class="row-left">收票人邮箱</div>
                    <div class="row-right">2131215@qq.components</div>
                </div>
                <div class="section-row">
                    <div class="row-left">发票内容</div>
                    <div class="row-right">明细</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from 'vant'

export default {
    components:{
        [Icon.name]:Icon
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    .top-block{
        overflow: hidden;
        height:120px;
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        .content-wrapper{
            margin-top: 22px;
            padding:0 22px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .info-block{
                margin-left: 10px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                .status{
                    color:#fff;
                    font-size: 17px;
                    font-weight: 500;
                    line-height: 24px;
                }
                .time{
                    color:#fff;
                    line-height: 17px;
                    font-size: 12px;
                }
            }
        }
    }
    .page-bottom{
        padding:0 10px;
        position: relative;
        top:-40px;
        .section{
            padding:15px;
            background:#fff;
            margin-bottom: 10px;
            @media screen and (max-width: 750px){
                border-radius: 4px;
            }
            .section-row{
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 20px;
                @include flex-between;
                &:last-child{
                    margin-bottom: 0;
                }
                &.goods-info{
                    align-items: flex-start;
                }
                .row-left{
                    color:#666;
                }
                .row-right{
                    color:#333;
                    .info-row{
                        margin-bottom: 7px;
                        max-width: 226px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>